/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const instagram = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#instagram_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.646 3.71h.347M4.733 1h6.534A3.733 3.733 0 0 1 15 4.733v6.534A3.733 3.733 0 0 1 11.267 15H4.733A3.733 3.733 0 0 1 1 11.267V4.733A3.733 3.733 0 0 1 4.733 1Zm6.378 7A3.111 3.111 0 1 1 4.89 8a3.111 3.111 0 0 1 6.222 0Zm.96-4.29c0 .182-.16.242-.248.242-.091 0-.251-.06-.251-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
      />
    </g>
    <defs>
      <clipPath id="instagram_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default instagram
